"use strict";

exports.__esModule = true;
exports.docSize = exports.docScroll = void 0;
var docScroll = {
  get top() {
    return document.documentElement.scrollTop || document.body.scrollTop;
  },

  get left() {
    return document.documentElement.scrollLeft || document.body.scrollLeft;
  },

  set top(value) {
    document.documentElement.scrollTop = value;
    document.body.scrollTop = value;
  },

  set left(value) {
    document.documentElement.scrollLeft = value;
    document.body.scrollLeft = value;
  }

};
exports.docScroll = docScroll;
var docSize = {
  get width() {
    return window.innerWidth || document.documentElement.clientWidth;
  },

  get height() {
    return window.innerHeight || document.documentElement.clientHeight;
  }

};
exports.docSize = docSize;